import React from "react";
import Header from "./Header";
import AllSections from "./AllSections";

const Home = () => {
  return (
    <div>
      <Header />
      <AllSections />
    </div>
  );
};

export default Home;
